export const DEFAULT_EPISODE = "bc26";
export const FIELD_REQUIRED_ERROR_MSG = "This field is required.";
